import { render, staticRenderFns } from "./c-textarea.vue?vue&type=template&id=de2f28f2&scoped=true&"
import script from "./c-textarea.vue?vue&type=script&lang=js&"
export * from "./c-textarea.vue?vue&type=script&lang=js&"
import style0 from "./c-textarea.vue?vue&type=style&index=0&id=de2f28f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2f28f2",
  null
  
)

export default component.exports